import _ from 'lodash';
import moment from 'moment';
import { MOMENT_TIME_FORMAT } from '../constants/date_format';

/*
 * Convert object(s) to SetTimetable class
 */
export const convertToTimetableObject = (items) => {
    return items.map((item) => {
        return {
            ...item,
            timeIn: moment(item.timeIn, MOMENT_TIME_FORMAT),
            timeOut: moment(item.timeOut, MOMENT_TIME_FORMAT),
            // date: moment(MOMENT_DATE_FORMAT)
        };
    });
};

export const WednesdayBreak = () => {
    return {
        id: 0,
        timeIn: moment('14:30:00', MOMENT_TIME_FORMAT),
        timeOut: moment('17:20:00', MOMENT_TIME_FORMAT),
        dayOfWeek: 'Wednesday',
        course: { courseNumber: 'Hour Break', subject: 'Three' },
    };
};

export const checkConflictWithBreak = (timetables) => {
    return _.find(timetables, function (t) {
        return t.dayOfWeek === 'Wednesday' && t.timeIn <= moment('17:30:00', MOMENT_TIME_FORMAT) && moment('14:30:00', MOMENT_TIME_FORMAT) <= t.timeOut;
    });
};

export const returnValueInObj = (obj:Object, string:string) => {
    let value, stringSplit = string.split('.');

    stringSplit.map((o,i)=>{
        i === 0 ? value = obj[o] : value = value[o]; 
    })

    return value;
}

export const changeValueInObj = (string:string, obj:Object, value:any) => {
    let ref = obj, stringSplit = string.split('.'), len = stringSplit.length;

    stringSplit.map((o,i)=>{
        if(i !== len-1) {
            if(!ref[o]) ref[o] = {};
            ref = ref[o];
        }; 
    });
    
    ref[stringSplit[len-1]] = value

    return obj;
}
